/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

/**
 * @description Flow relative to the tenant: inbound from a contact/prospect, outbound from the team, or unknown.
 */
export const interactionDirectionSchema = z.enum(["in", "out", "unk"]).describe("Flow relative to the tenant: inbound from a contact/prospect, outbound from the team, or unknown.")